
// Product JS for product forms
export class ProductForm {

    constructor(form) {

        this.form = form;
        // this.json = json;
        this.master_select = this.form.querySelector('select.product-master-selector');

        this.translations = {
            addToCart: this.form.dataset.addToCart,
            soldOut: this.form.dataset.soldOut,
            unavailable: this.form.dataset.unavailable,
            chooseOption: this.form.dataset.chooseOption,
            pleaseSelect: this.form.dataset.pleaseSelect,
            saving: this.form.dataset.saving,
        }

        this.selectors = {
            radioOption: 'radio-option',
            radioLabel: 'radio-label',
            singleOptionSelector: 'single-option-selector',
            quantityContainer: 'quantity-selector',
            quantityInput: 'quantity-input',
            quantityPlus: 'quantity-plus',
            quantityMinus: 'quantity-minus',
            addToCart: 'add-to-cart',
            soldOut: 'sold-out',
            priceContainer: 'product-price',
            optionContainer: 'product-option-wrapper',
            optionHeadingContainer: 'option-heading-wrapper',
            optionHeadingName: 'option-name',
            optionRadios: 'option-radios',
            productSwatches: 'product-swatches',
            productSwatchName: 'swatch-name',
            productSwatch: 'swatch',
            stockIndicator: 'stock-indicator',
            customSelectWrapper: 'custom-select-wrapper',
            customSelectOutput: 'select-output',
            klaviyoForm: 'klaviyo-notify-form',
            klaviyoInput: 'notify_email',
            klaviyoSubmit: 'klaviyo-bis-trigger'
        }

        this.fetchProductJSON();
    }



    init() {
        this.form.addEventListener('click', this.handleClickEvents.bind(this));
        this.form.addEventListener('change', this.handleChangeEvents.bind(this));

        this.selectedVariantOnLoad();
        this.initMasterSelectCallback();

        // Init Selected Variant Variable
        const first_or_selected_variant_on_load = this.selected_or_first_available_variant;
        this.selected_variant = first_or_selected_variant_on_load;
        if ( first_or_selected_variant_on_load ) {
            this.resetQuantity(first_or_selected_variant_on_load.id);
            this.checkVariantAvailability(first_or_selected_variant_on_load.id);
            this.updateVariantInfo(first_or_selected_variant_on_load.id);
        }


        // Disable Sold Out variants
        this.disableSoldOutRadios();
        this.disableUnavailableRadios();


        this.updateOptionHeadings();
        this.showLabelsOnHover();
        this.updateAddToCartStatus(this.selected_variant);
        this.master_select.dispatchEvent(new Event('change'));
    }



    handleClickEvents(e) {
        // console.log('Click! ', e.target);
        this.optionRadios(e);
        this.quantityControls(e);
        this.handleAddToCart(e);
        this.klaviyoBackInStock(e);
        // this.initCustomSelects(e);
    }


    handleChangeEvents(e) {
        const select = e.target;
        if ( !select.classList.contains('single-option-selector') ) {
            return;
        } else {
            this.optionSelects(e);

        }
    }



    handleAddToCart(e) {
        if (e.target.classList.contains(this.selectors.addToCart)) {
            e.preventDefault();
            const addToCart = e.target;

            const errorLines = {
                "Recipient name": "Please provide a name for the Recipient",
                "Recipient email": "Please provide the Recipient's email",
                "Recipient from": "Please provide the sender's name",
                "Message": "Please add a message",
                "Send on": "Please choose a date to send on",
            }

            let emptyValues = 0;

            if (document.querySelector(".recipient-fields")) {
                console.log('Recipients Form Found!:', e.target);
                const recipientForm = document.querySelector(".recipient-form");
                const checkbox = recipientForm.querySelector('input[type="checkbox"]')
                
                if (checkbox.checked) {

                const recipientFields = document.querySelectorAll('.field__input.property');
                
                recipientFields.forEach(field => {
                    if (field.disabled) return;

                   if (field.classList.contains('error')) {
                        field.classList.remove('error')
                   }

                    const value = field.value;

                    if (value.length == 0) {
                        emptyValues++;
                        field.classList.add('error');

                        let options = {
                            message: `${errorLines[field.name]}`,
                            background: "#b40303",
                            delay: 5000
                          }

                        window.toasty.addToast(options);
                        return;
                    }
                });
                }
            }

            if (emptyValues > 0) return;

            const variant_id = this.master_select.value;
            const quantityInput = this.form.querySelector(`.${this.selectors.quantityContainer} .${this.selectors.quantityInput}`);
            const quantity = quantityInput.value;

            const propertyFields = this.form.querySelectorAll(".property");
            const properties = {};

            if (propertyFields) {
                propertyFields.forEach(field => {
        
                  const key = field.getAttribute('name');
                  const value = field.value;
                  if (key && value) {
                    properties[key] = value;
                  }
                });
              }

            let formData = {
                'items': [{
                    'id': variant_id,
                    'quantity': quantity,
                    'properties': properties
                }]
            };
            // console.log('Add to Cart Clicked! ', addToCart, ' formData: ', formData);

            // Add to cart
            window.cart.add(formData);

        }
    }



    // Fetch Product JS before Init
    async fetchProductJSON() {
        const handle = this.master_select.dataset.productHandle;
        const url = `${window.Shopify.routes.root}products/${handle}.js`;

        fetch(url)
            .then(response => response.json()) // Read the body as JSON
            .then(data => {
                this.json = data;
                // console.log('🐷🐷🐷 PRODUCT JSON: ', data);
                this.init()
            })
            .catch(error => {
                console.error('Error fetching product JSON:', error);
            });
    }



    updateURLVariantParameters(variant_id) {
        if ( !this.form.classList.contains('product-card-form') ) {
            if (variant_id && variant_id != 'null' ) {

                const url = new URL(window.location.href);
                const params = new URLSearchParams(url.search);
                const key = 'variant';
                if (params.has(key)) params.set(key, variant_id);
                else params.append(key, variant_id);

                url.search = params.toString();
                window.history.replaceState({}, '', url);

            }

        }
    }



    selectedVariantOnLoad() {

        // Do not get Variant URL if
        let variantURL = null;
        if ( !this.form.classList.contains('product-card-form') ) {
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString)
            variantURL = urlParams.get('variant');
        }
        // console.log( '🧨🧨🧨 variantURL: ', variantURL )


        const updateRadios = (selected_or_first_available) => {
            // THEN Select Variant Option Radios + Selects programatically
            const options = selected_or_first_available?.options;
            if ( options ) {

                options.forEach((option, index) => {
                    const optionPosition = index + 1;
                    // console.log( 'option: ', option, '  | optionPosition: ', optionPosition );

                    // Select Option Radio
                    const optionRadios = this.form.querySelectorAll(`.${ this.selectors.radioOption }`);
                    optionRadios.forEach( optionRadio => {
                        const optionRadioPosition = optionRadio.dataset.optionPosition;
                        const radioValue = optionRadio.value;

                        if ( optionPosition == optionRadioPosition && radioValue == option ) {
                            optionRadio.checked = true;

                            const optionRadioSelect = optionRadio.closest(`.${ this.selectors.optionContainer }`)?.querySelector('.select-output');
                            if ( optionRadioSelect ) optionRadioSelect.textContent = optionRadio.value;
                        }
                    });
                    /*
                    const optionRadio = this.form.querySelector(`.${this.selectors.optionRadios}[data-option-position="${optionPosition}"] .${this.selectors.radioOption}[value="${option}"]`);
                    if ( optionRadio ) {
                        // console.log( 'optionRadio: ', optionRadio );
                        optionRadio.checked = true;

                        const optionRadioSelect = optionRadio.closest(`.${ this.selectors.optionContainer }`)?.querySelector('.select-output');
                        if ( optionRadioSelect ) optionRadioSelect.textContent = optionRadio.value;
                    }
                    */

                    // Select Option Select
                    const optionSelect = this.form.querySelector(`select.${ this.selectors.singleOptionSelector }[data-option-position="${ optionPosition }"]`);
                    if ( optionSelect ) {
                        // console.log('optionSelect onLoad: ', optionSelect);
                        optionSelect.value = option;
                    }

                });

            }
        }






        if ( this.json.variants.length == 1 ) {
            // console.log('Only one variant.. Just select it!')

            this.master_select.value = this.json.variants[0].id;

            let selected_or_first_available = this.json.variants[0];


            updateRadios(selected_or_first_available);
            this.updateURLVariantParameters(selected_or_first_available.id);
            this.checkVariantAvailability(selected_or_first_available.id);

            this.selected_or_first_available_variant = selected_or_first_available;

        } else if ( !variantURL || variantURL == 'null' ) {
            // console.log('🧨🧨🧨 No Variant Selected on load...');

            // Select option radios with only single radio
            const allOptionContainers = this.form.querySelectorAll(`.${ this.selectors.optionRadios }`);
            allOptionContainers.forEach( optionContainer => {
                const optionRadios = optionContainer.querySelectorAll(`.${ this.selectors.radioOption }`);
                // console.log( 'optionRadios: ', optionRadios, ' | length: ', optionRadios.length )
                if ( optionRadios.length == 1 ) {
                    optionRadios.forEach( radio => {
                        radio.checked = true;
                    });
                }

            });

            return

        } else {

            this.master_select.value = variantURL;
            const selected_variant_id = this.master_select.value;
            const everyVariantSoldOut = this.json.variants.every(variant => variant.available == false);


            let selected_or_first_available = this.json.variants.find( variant => variant.id == selected_variant_id );
            // Default to First Variant if sold out
            if ( !selected_or_first_available && everyVariantSoldOut ) selected_or_first_available = this.json.variants[0];


            updateRadios(selected_or_first_available);
            this.updateURLVariantParameters(selected_or_first_available.id);
            this.checkVariantAvailability(selected_or_first_available.id);

            this.selected_or_first_available_variant = selected_or_first_available;

        }
    }



    initMasterSelectCallback() {
        this.master_select.addEventListener('change', () => {
            const selected_variant = this.json.variants.find(variant => variant.id == this.master_select.value);
            const variant_id = selected_variant ? selected_variant.id : null;

            // Update Selected Variant Variable
            this.selected_variant = selected_variant ? selected_variant : null;
            // Update URL Parmaters
            this.updateURLVariantParameters(variant_id);

            // Actions on Change
            this.resetQuantity(variant_id);
            this.checkVariantAvailability(variant_id);
            this.updateVariantInfo(variant_id);
            this.disableUnavailableRadios();
            this.updateOptionHeadings();
            this.setDeliveryElements(selected_variant);
        });
    }



    checkVariantAvailability(variant_id) {
        // const selected_variant = this.json.variants.find( variant => variant.id == variant_id );
        this.updateAddToCartStatus(this.selected_variant);

        let availability;
        if (this.selected_variant) availability = this.selected_variant.available;
        else availability = false;
    }



    updateAddToCartStatus(variant) {
        const addToCart = this.form.querySelector(`.${this.selectors.addToCart}`);

        const selected_options = this.form.querySelectorAll(`input:checked.${this.selectors.radioOption}, select.${ this.selectors.singleOptionSelector }`);
        // const selected_options_arr = [...new Set( Array.from(selected_options).map(option => option.value) )];
        const selected_options_arr = Array.from(selected_options).map(option => option.value);

        const allOptionContainers = this.form.querySelectorAll(`.${ this.selectors.optionContainer }`);


        // Not enough options selected
        if ( selected_options_arr.length != this.json.options.length ) {
            addToCart.disabled = true;
            addToCart.querySelector('.text').innerHTML = 'Choose an option';
            addToCart.classList.add('no-variant-selected');
            addToCart.classList.remove('unavailable', 'available', 'sold-out');
            allOptionContainers.forEach( optionContainer => {
                optionContainer.classList.remove('no-option-selected');
            })

            const unselectedOptionContainers = Array.from( allOptionContainers ).filter( container => {
                return !container.querySelector(`.${ this.selectors.radioOption }:checked`);
            });
            // console.log('unselectedOptionContainers', unselectedOptionContainers)
            setTimeout(() => {

                if ( unselectedOptionContainers && unselectedOptionContainers.length > 0 ) {
                    unselectedOptionContainers.forEach( unselectedOption => {
                        unselectedOption.classList.add('no-option-selected');
                    });

                    // Update AddToCart Text
                    const unselectedOptionMessage = unselectedOptionContainers[0].dataset.option;
                    addToCart.querySelector('.text').innerHTML = `${ this.translations.pleaseSelect } ${ unselectedOptionMessage }`;
                }

            }, 10);

        } else if (variant) {
            const availability = variant.available;

            // Remove no option selected Classes
            addToCart.classList.remove('no-variant-selected');
            allOptionContainers.forEach( optionContainer => {
                optionContainer.classList.remove('no-option-selected');
            });

            if (availability == true) {
                addToCart.removeAttribute('disabled');

                addToCart.classList.add('available');
                addToCart.classList.remove('unavailable', 'sold-out');

                addToCart.querySelector('.text').innerHTML = this.translations.addToCart;
                // console.log('enabling add to cart button...');

            } else {
                addToCart.disabled = true;

                addToCart.classList.add('sold-out');
                addToCart.classList.remove('unavailable', 'available');

                addToCart.querySelector('.text').innerHTML = this.translations.soldOut;
                // console.log('disabling add to cart button...');

            }

        } else {
            // Product Unavailable
            addToCart.disabled = true;

            addToCart.classList.add('unavailable');
            addToCart.classList.remove('available', 'sold-out');

            addToCart.querySelector('.text').innerHTML = this.translations.unavailable;
        }
    }



    updateOptionHeadings() {
        const selected_radios = this.form.querySelectorAll(`.${this.selectors.optionContainer} input.${this.selectors.radioOption}:checked`);

        if (selected_radios) {
            selected_radios.forEach(selected_radio => {
                let radio_value = selected_radio.value;
                const optionContainer = selected_radio.closest(`.${this.selectors.optionContainer}`);
                const optionHeading = optionContainer.querySelector(`.${this.selectors.optionHeadingContainer}`);
                const customSelectEl = optionContainer.querySelector('.select-output');

                if (optionContainer && optionHeading) {
                    const optionHeadingName = optionHeading.querySelector(`.${this.selectors.optionHeadingName}`);

                    if ( selected_radio.classList.contains('sold-out') ) radio_value = selected_radio.value + ` - ${ this.translations.soldOut }`;
                    else if ( selected_radio.classList.contains('unavailable') ) radio_value = selected_radio.value + ` - ${ this.translations.soldOut }`;

                    if ( optionHeadingName ) {
                        if ( radio_value ) {

                            if ( optionHeadingName ) {
                                optionHeadingName.textContent = radio_value;
                                optionHeadingName.dataset.selectedOption = radio_value;

                                if ( customSelectEl ) customSelectEl.textContent = radio_value;
                            }

                        } else {
                            if ( optionHeadingName ) optionHeadingName.textContent = `${this.translations.chooseOption}...`;
                        }
                    }
                }

            });
        }


        // Update Select Headings
        const selected_selects = this.form.querySelectorAll(`.${ this.selectors.singleOptionSelector }`);
        if ( selected_selects ) {

            selected_selects.forEach( select => {
                const selected_option = select.options[select.selectedIndex];

                const option_value = selected_option.value;
                const option_heading = select.closest(`.${this.selectors.optionContainer}`).querySelector(`.${this.selectors.optionHeadingContainer}`);
                if (option_heading) {
                    const option_heading_name = option_heading.querySelector(`.${this.selectors.optionHeadingName}`);
                    if ( option_heading_name ) {
                        if ( option_value ) {
                            option_heading_name.textContent = option_value;
                            option_heading_name.dataset.selectedOption = option_value;
                        } else {
                            option_heading_name.textContent = '';
                        }
                    }
                }

            });

        }

    }



    optionRadios(e) {
        let target = e.target;
        
        if ( target.classList.contains(this.selectors.radioOption) || target.classList.contains(this.selectors.radioLabel) ) {
            
            // Update target in case multiple inputs with the same ID exist
            if ( target.classList.contains(this.selectors.radioLabel) ) {
                e.preventDefault();
                target = target.previousElementSibling;
                target.checked = true;
            }
            
            
            // Add interacted class to form
            if ( !this.form.classList.contains('form-interacted') ) this.form.classList.add('form-interacted');

            const radioOptionPosition = target.getAttribute('data-option-position');

            // Check if Single Option Select Exists
            const singleOptionSelect = this.form.querySelector(`select.${ this.selectors.singleOptionSelector }[data-option-position="${ radioOptionPosition }"]`);
            if ( singleOptionSelect ) {
                // console.log('singleOptionSelect: ', singleOptionSelect);
                singleOptionSelect.value = target.value;
            }


            // Update Master Select
            const selected_variant = this.findVariantFromOptions();
            if ( selected_variant ) this.master_select.value = selected_variant.id;
            else this.master_select.value = '';
            // console.log('🐷 selected_variant', selected_variant, ' |  🐷 Master value: ', this.master_select.value );

            this.master_select.dispatchEvent(new Event('change'));

        }
    }



    optionSelects(e) {
        const select = e.target;

        // console.log('Single Option Selector Changed!', select );
        const selectOptionPosition = select.getAttribute('data-option-position');

        // Check if Radio with Same Value Exists
        const optionRadios = this.form.querySelectorAll(`input.${ this.selectors.radioOption }[data-option-position="${ selectOptionPosition }"]`);
        if ( optionRadios ) {
            optionRadios.forEach( optionRadio => {
                if ( optionRadio.value == select.value ) {
                    optionRadio.checked = true;
                    // console.log('Found Selects Radio!');
                } else {
                    optionRadio.checked = false;
                }
            });
        }

        // Update Master Select
        const selected_variant = this.findVariantFromOptions();
        if ( selected_variant ) this.master_select.value = selected_variant.id;
        else this.master_select.value = '';
        // console.log('🐷 selected_variant', selected_variant, ' |  🐷 Master value: ', this.master_select.value );

        this.master_select.dispatchEvent(new Event('change'));
    }



    findVariantFromOptions() {
        const variants = this.json.variants;
        const selected_options = this.form.querySelectorAll(`input:checked.${this.selectors.radioOption}, select.${ this.selectors.singleOptionSelector }`);
        // const selected_options_arr = [...new Set( Array.from(selected_options).map(option => option.value) )];
        // const selected_options_arr = Array.from(selected_options).map(option => option.value);
        let matched_variant = null;

        // Generate EMPTY Options Object
        const selectedOptionsObj = {};
        const optionLength = this.json.options.length;
        for ( let i = 0; i < optionLength; i++ ) { selectedOptionsObj[`option${ i + 1 }`] = null; }


        selected_options.forEach( selectedOption => {
            const selectedOptionPosition = selectedOption.dataset.optionPosition;
            selectedOptionsObj[`option${selectedOptionPosition}`] = selectedOption.value;
        });
        // console.log( '⭐️⭐️⭐️ SELECTED OPTIONS OBJECT: ', selectedOptionsObj );

        for ( let v = 0; v < variants.length; v++ ) {
            const variant = variants[v];

            // Step 1: Check if the variant object matches these options
            const hasMatchingOptions = Object.entries(selectedOptionsObj).every(([key, value]) => variant[key] === value);

            if ( hasMatchingOptions ) {
                matched_variant = variant;
                break
            }
        };
        return matched_variant;
    }



    quantityControls(e) {
        const target = e.target;
        const quantityContainer = target.closest(`.${this.selectors.quantityContainer}`)
        if (quantityContainer) {
            const quantity_input = quantityContainer.querySelector(`.${this.selectors.quantityInput}`);
            let quantity = parseInt(quantity_input.value);
            const min = quantity_input.min;
            const max = quantity_input.max ? quantity_input.max : 99999;
            let new_value;

            if (target.classList.contains(this.selectors.quantityMinus)) new_value = quantity - 1;
            else if (target.classList.contains(this.selectors.quantityPlus)) new_value = quantity + 1;

            if (new_value > 0 && new_value <= max) {
                quantity_input.value = new_value;
                // console.log('🧨🧨🧨 quantity updated... ', `min: ${min} | max: ${max} | new_value: ${new_value}` );

                if (new_value == min) quantityContainer.classList.add('min-reached');
                else quantityContainer.classList.remove('min-reached');

                if (new_value == max) quantityContainer.classList.add('max-reached');
                else quantityContainer.classList.remove('max-reached');
            }
        }
    }



    resetQuantity() {
        const quantityContainer = this.form.querySelector(`.${this.selectors.quantityContainer}`);
        const quantityInput = quantityContainer.querySelector(`.${this.selectors.quantityInput}`);
        const stockIndicator = this.form.querySelector(`.${ this.selectors.stockIndicator }`);

        if (quantityContainer && quantityInput && this.selected_variant) {
            const variant = this.selected_variant;
            let inventory_quantity = 0;

            let matchingOption = null;
            if ( variant ) {

                for (let i = 0; i < this.master_select.options.length; i++) {
                    if (this.master_select.options[i].value == variant.id) {
                        matchingOption = this.master_select.options[i];
                        break;
                    }
                }

                if ( matchingOption != null ) inventory_quantity = matchingOption.dataset.inventoryQuantity;
            }

            const inventory_management = variant ? variant.inventory_management : null;

            if ( inventory_quantity <= 0 && inventory_management != null ) {
                quantityInput.value = 0;
                quantityInput.max = 0;
                quantityContainer.classList.add('disabled');

                quantityContainer.classList.remove('min-reached', 'max-reached');
                quantityContainer.classList.add('out-of-stock');

                if ( stockIndicator ) stockIndicator.innerHTML = '';

            } else {
                quantityInput.value = 1;
                quantityInput.max = inventory_quantity > 0 ? inventory_quantity : 9999;
                quantityContainer.classList.remove('disabled');


                quantityContainer.classList.remove('out-of-stock');

                if (quantityInput.min == quantityInput.value) quantityContainer.classList.add('min-reached');
                else quantityContainer.classList.remove('min-reached');

                if (quantityInput.max == quantityInput.value) quantityContainer.classList.add('max-reached');
                else quantityContainer.classList.remove('max-reached');


                // Stock Indicator
                if ( stockIndicator ) {
                    if ( quantityInput.max <= 3 ) stockIndicator.innerHTML = `Only ${ quantityInput.max } left in stock!`;
                    else stockIndicator.innerHTML = '';
                }
            }

            // console.log('inventory quantity: ', inventory_quantity)
        }
    }



    // Generate HTML for Variant Price
    generatePriceHTML(variant) {
        const priceContainer = this.form.querySelector(`.${this.selectors.priceContainer}`);
        const list_price_type = priceContainer ? priceContainer.dataset.listPriceType : '';
        let html;

        if ( !variant ) {
            // priceContainer.style.display = 'none';

        } else {
            const price = variant ? variant.price : null;
            const compare_at_price = variant ? variant.compare_at_price : null;
            let savings = null;

            if ( price && compare_at_price ) {
                savings = compare_at_price - price;
            }

            // console.log('price: ', price, ' compare_at_price: ', compare_at_price, ' savings: ', savings)

            priceContainer.style.display = 'flex';

            if ( savings != null && savings > 0 ) {

                let style = '';
                if ( list_price_type == '' ) style = 'style="text-decoration: line-through;"';

                html = `
                    <div class="price">${this.formatMoney(price)}</div>
                    <div class="sale-price" ${ style }> ${ list_price_type } ${this.formatMoney(compare_at_price)}</div>
                    <div class="savings">${ this.translations.saving } ${ this.formatMoney(savings) }</div>
                `;

            } else if (compare_at_price > price) {
                // Is on Sale
                html = `
                    <div class="sale-price">${ list_price_type } ${this.formatMoney(compare_at_price)}</div>
                    <div class="price">${this.formatMoney(price)}</div>
                `;

            } else {
                html = `<div class="price">${this.formatMoney(price)}</div>`;
            }

        }
        return html;
    }



    // Format Money Helper
    formatMoney(amount) {
        const format = Shopify.money_format;
        return Shopify.formatMoney(amount, format)
    }



    // Update Variant Information
    updateVariantInfo() {
        const priceContainer = this.form.querySelector(`.${this.selectors.priceContainer}`);

        const price_html = this.generatePriceHTML(this.selected_variant);
        if ( priceContainer && price_html != undefined ) priceContainer.innerHTML = price_html;

        // Get Variant Option from Master Select
        let matchingOption = null;
        if ( this.selected_variant ) {

            for (let i = 0; i < this.master_select.options.length; i++) {
                if (this.master_select.options[i].value == this.selected_variant.id) {
                    matchingOption = this.master_select.options[i];
                    break;
                }
            }

        }

        // Product / Variant Sku
        const variant_sku_el = this.form.querySelector('.variant-sku');
        if ( variant_sku_el ) {
            const quick_code_t = variant_sku_el.dataset.quickCode;
            let parentSku = variant_sku_el.dataset.parentSku ? variant_sku_el.dataset.parentSku : null;
            let variantSku = this.selected_variant && this.selected_variant.sku ? this.selected_variant.sku : parentSku;

            if ( variantSku != null ) {

                variant_sku_el.innerHTML = `${quick_code_t}: ${ variantSku }`;
                variant_sku_el.style.display = 'block';

            } else {
                variant_sku_el.style.display = 'none';
                // console.log('No Sku to Show!')
            }

        }

        /*
        const stock_locations_el = this.form.querySelector('[data-stock-locations]');
        if ( stock_locations_el ) {

            if ( !this.selected_variant || this.selected_variant.available != true ) {
                stock_locations_el.style.display = 'none';
            } else {
                stock_locations_el.style.display = 'flex';
            }

        }
        */


    }



    // Disable Radios that have NO variant available with that option
    disableSoldOutRadios() {
        const all_variants = this.json.variants;
        const radioOptionContainers = this.form.querySelectorAll(`.${this.selectors.optionRadios}`);
        // console.log('all variants: ', all_variants);

        if (radioOptionContainers) {
            radioOptionContainers.forEach(radioOptionContainer => {
                const optionPosition = radioOptionContainer.getAttribute('data-option-position');
                const optionVar = `option${optionPosition}`;
                const optionRadios = radioOptionContainer.querySelectorAll(`.${this.selectors.radioOption}`);


                optionRadios.forEach(optionRadio => {
                    const optionVariants = all_variants.filter(variant => variant[optionVar] == optionRadio.value);
                    const areAllUnavailable = optionVariants.every(variant => variant.available === false);
                    // console.log('optionRadio: ', optionRadio.value, ' | optionVariants: ', optionVariants, ' | areAllUnavailable: ', areAllUnavailable );

                    // No Variants with Option Available
                    if (areAllUnavailable == true) {
                        const radioOptionImg = optionRadio.nextElementSibling.querySelector('img');
                        optionRadio.classList.add('unavailable', 'sold-out');
                        if ( !radioOptionImg ) {
                            const textNode = document.createTextNode(` - ${ this.translations.soldOut }`);
                            optionRadio.nextElementSibling.appendChild( textNode );
                        }
                    }

                });

            });
        }
    }



    // Disable Radios that aren't available with the current Selection
    /*
    ** Get Selected Options
    ** Swap Selected Option using Option Position from Array
    ** Find Variant
    ** Check availablity, return null if there is no variant
    */
    disableUnavailableRadios() {
        const variants = this.json.variants;
        const selected_options = this.form.querySelectorAll(`input:checked.${this.selectors.radioOption}, select.${ this.selectors.singleOptionSelector }`);
        // const selected_options_arr = [...new Set( Array.from(selected_options).map(option => option.value) )];
        const selected_options_arr = Array.from(selected_options).map(option => option.value);

        // const radioOptionContainers = this.form.querySelectorAll(`.${ this.selectors.optionRadios }`);
        const radioOptions = this.form.querySelectorAll(`.${ this.selectors.radioOption }`);
        // console.log('⭐️⭐️⭐️ SELECTED OPTIONS ARRAY: ', selected_options_arr );
        const arrayValuesMatch = (a, b) => JSON.stringify(a.sort()) === JSON.stringify(b.sort());

        if ( selected_options_arr.length >= 1 ) {

            // Generate EMPTY Options Object
            const selectedOptionsObj = {};
            const optionLength = this.json.options.length;
            for ( let i = 0; i < optionLength; i++ ) { selectedOptionsObj[`option${ i + 1 }`] = null; }


            selected_options.forEach( selectedRadio => {
                const radioOptionPosition = selectedRadio.dataset.optionPosition;
                selectedOptionsObj[`option${ radioOptionPosition }`] = selectedRadio.value;
            });
            const selectedOptionsArr = Object.values(selectedOptionsObj);
            // console.log( 'SELECTED OPTIONS OBJ: ', selectedOptionsObj, '  |  SELECTED OPTIONS ARR: ', selectedOptionsArr );


            radioOptions.forEach( radioOption => {
                const radioOptionPosition = radioOption.dataset.optionPosition;
                const arrayPosition = radioOptionPosition - 1;
                const radioOptionImg = radioOption.nextElementSibling.querySelector('img');

                // let options_with_radio_selected = [...selected_options_arr];
                // options_with_radio_selected[ arrayPosition ] = radioOption.value;
                // options_with_radio_selected = options_with_radio_selected.filter( value => value !== null && value !== undefined && value !== '' );
                // console.log('options_with_radio_selected: ', options_with_radio_selected);

                let options_with_radio_selected = { ...selectedOptionsObj };
                options_with_radio_selected[`option${radioOptionPosition}`] = radioOption.value;

                let isAvailable = false;
                for ( let v = 0; v < variants.length; v++ ) {
                    const variant = variants[v];
                    // Step 1: Filter out keys with null values from options_with_radio_selected
                    const filteredOptions = Object.entries(options_with_radio_selected)
                    .filter(([key, value]) => value !== null)
                    .reduce((acc, [key, value]) => {
                        acc[key] = value;
                        return acc;
                    }, {});

                    // Step 2: Check if the variant object matches these options
                    const hasMatchingOptions = Object.entries(filteredOptions).every(([key, value]) => variant[key] === value);

                    if ( hasMatchingOptions && variant.available == true ) {
                        isAvailable = true;
                        break
                    }
                };

                if ( isAvailable == false ) {
                    radioOption.classList.add('unavailable');
                    if ( ( !radioOption.nextElementSibling.textContent.includes(` - ${ this.translations.soldOut }`) && !radioOption.nextElementSibling.textContent.includes(` - ${ this.translations.soldOut }`) ) && !radioOptionImg ) {
                        radioOption.nextElementSibling.textContent = radioOption.nextElementSibling.textContent + ` - ${ this.translations.soldOut }`;
                    }
                } else {
                    radioOption.classList.remove('unavailable');
                    if ( !radioOptionImg ) radioOption.nextElementSibling.textContent = radioOption.nextElementSibling.textContent.replace(` - ${ this.translations.soldOut }`, "");
                }

            });
        } else {
            // console.log('🚫 NO OPTIONS SELECTED...');
            return
        }

    }



    showLabelsOnHover() {
        const optionContainers = this.form.querySelectorAll(`.${this.selectors.optionContainer}`);

        // console.log('swatchContainer: ', swatchContainer);

        optionContainers.forEach( optionContainer => {
            const optionNameEl = optionContainer.querySelector(`.${ this.selectors.optionHeadingName }`);
            const radios = optionContainer.querySelectorAll(`.${ this.selectors.radioOption }`);
            const customSelectEl = optionContainer.querySelector('.select-output');

            if ( radios ) {

                radios.forEach( radio => {

                    radio.nextElementSibling.addEventListener('mouseover', () => {
                        // Add Sold Out if Needed
                        let radio_label = radio.value;
                        if ( radio.classList.contains('sold-out') ) radio_label = radio.value + ` - ${ this.translations.soldOut }`;
                        else if ( radio.classList.contains('unavailable') && !radio.classList.contains('sold-out') ) radio_label = radio.value + ` - ${ this.translations.soldOut }`;

                        if ( optionNameEl ) optionNameEl.textContent = radio_label;
                        if ( customSelectEl ) customSelectEl.textContent = radio_label;
                    });
                    radio.nextElementSibling.addEventListener('mouseout', () => {

                        if ( optionNameEl ) optionNameEl.textContent = optionNameEl.dataset.selectedOption;
                        if ( customSelectEl ) customSelectEl.textContent = optionNameEl.dataset.selectedOption;
                    });
                });

            };
        });

    }

    /*
    initCustomSelects(e) {
        const target = e.target;
        const customSelects = this.form.querySelectorAll(`.${this.selectors.customSelectWrapper}`);

        if ( customSelects && customSelects.length > 0 ) {

            customSelects.forEach( customSelect => {
                customSelect.classList.remove('active');
            });

            if ( target.classList.contains( this.selectors.customSelectOutput ) && !target.closest(`.${ this.selectors.customSelectWrapper }`).classList.contains('active') ) {
                target.closest(`.${ this.selectors.customSelectWrapper }`).classList.add('active');
            }

        }
    }
    */

    // Klaviyo Form
    klaviyoBackInStock (e) {
        const target = e.target;
        if ( target.classList.contains( this.selectors.klaviyoSubmit ) ) {
            e.preventDefault();
            const variantID = this.selected_variant ? this.selected_variant.id : null;
            const klaviyoForm = target.closest(`.${ this.selectors.klaviyoForm }`);
            const klaviyoAPIKey = klaviyoForm?.dataset.klaviyoApiKey;
            const klaviyoEmailInput = klaviyoForm?.querySelector(`#${ this.selectors.klaviyoInput }`);
            const klaviyoSubmit = target;

            let responseMessage = '';

            if ( klaviyoForm && klaviyoEmailInput && klaviyoAPIKey && variantID != null ) {
                const klaviyoTranslations = {
                    error: klaviyoForm.dataset.error,
                    success: klaviyoForm.dataset.success,
                    notify: klaviyoForm.dataset.notify,
                    sending: klaviyoForm.dataset.sending,
                };

                // console.log('⭐️⭐️⭐️ Klaviyo Form Submiting...');

                // Clear Form messages
                const responseMessages = klaviyoForm.querySelectorAll('.form-message');
                if ( responseMessages.length > 0 ) {
                    responseMessages.forEach( msg => {
                        msg.remove();
                    });

                };

                // Set sending message
                klaviyoSubmit.textContent = klaviyoTranslations.sending;
                klaviyoSubmit.classList.add('disabled');

                const email = klaviyoEmailInput.value;

                // Submit Form
                const myHeaders = new Headers({
                        "revision": "2024-07-15",
                        "Content-Type": "application/json",
                        "Accept": "application/json"
                    });
                    const raw = JSON.stringify({
                        data: {
                            type: "back-in-stock-subscription",
                            attributes: {
                            channels: ["EMAIL"],
                            profile: {
                                data: {
                                    type: "profile",
                                    attributes: {
                                        email: email
                                    }
                                }
                            }
                            },
                            relationships: {
                            variant: {
                                data: {
                                    type: "catalog-variant",
                                    id: `$shopify:::$default:::${ variantID }`
                                }
                            }
                            }
                        }
                    });

                    const requestOptions = {
                        method: 'POST',
                        headers: myHeaders,
                        body: raw,
                        redirect: 'follow'
                    };

                    fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${ klaviyoAPIKey }`, requestOptions)
                    .then(response => {
                        if (response.ok === true) {
                            // Display success message
                            responseMessage = klaviyoTranslations.success;
                            klaviyoForm.appendChild( createFormMessage( responseMessage, 'success') );

                            klaviyoEmailInput.value = "";
                            klaviyoSubmit.textContent = klaviyoTranslations.notify;
                            klaviyoSubmit.classList.remove('disabled');


                        } else {
                            // Display error message
                            // responseMessage = "Error: " + data.error_message;
                            const errors = data?.errors;
                            if ( errors.length > 0 ) {
                                errors.forEach( error => {
                                    responseMessage = error.detail;
                                    klaviyoForm.appendChild( createFormMessage( error.detail, 'error') );
                                });
                            } else {
                                responseMessage = klaviyoTranslations.error;
                                klaviyoForm.appendChild( createFormMessage( responseMessage, 'error') );
                            }
                            klaviyoSubmit.classList.remove('disabled');
                            klaviyoSubmit.textContent = klaviyoTranslations.notify;
                        }
                    })
                    .catch(error => {
                        // Display error message if the API request fails
                        // messageContainer.textContent = klaviyoTranslations.error;
                        responseMessage = klaviyoTranslations.error;
                        klaviyoForm.appendChild( createFormMessage( responseMessage, 'error') );
                        klaviyoSubmit.classList.remove('disabled');
                        klaviyoSubmit.textContent = klaviyoTranslations.notify;
                    });

            }

            function createFormMessage( message, className ) {
                const node = document.createElement('div');
                node.classList.add( 'form-message', className );
                node.innerHTML = message;

                return node;
            }

        }
    }



    setDeliveryElements(variant) {
        const deliveryElementSelectors = {
            stock_locations_el: "[stock-locations]",
            countdown_timer_el: "[variant-countdown-timer]",
            stock_information_el: "[variant-stock-information]",
            stock_locations: "data-stock-locations",
            in_store_el: "[variant-in-store]",
            in_store_text_el: "[store-online-text]",
            in_store_availability: "[variant-in-store]",
            in_store_online_text: "data-in-store-online-text",
            in_online_only_text: "data-online-only-text",
            stock_despatch_text: "data-stock-despatch-text",
            data_feed_text: "data-feed-text",
            feed_stock_text_el: '[feed-stock-text]',
        };

        const stock_locations_el = this.form.querySelector(deliveryElementSelectors.stock_locations_el);
        if ( stock_locations_el ) {

            if (!variant) {
                stock_locations_el.style.display = "none";
                return;
            }
            if (!variant.available) {
                if (stock_locations_el) {
                    stock_locations_el.style.display = "none";
                    return;
                }
            }
            if (stock_locations_el) {
                stock_locations_el.style.display = "flex";
                // GET ELEMENTS
                const stock_information_el = stock_locations_el.querySelector(deliveryElementSelectors.stock_information_el);
                const feed_text_el = stock_locations_el.querySelector(deliveryElementSelectors.feed_stock_text_el);
                const countdown_el = stock_locations_el.querySelector(deliveryElementSelectors.countdown_timer_el);
                const stock_available_el = stock_locations_el.querySelector(deliveryElementSelectors.in_store_el);
                const stock_available_text_el = stock_locations_el.querySelector(deliveryElementSelectors.in_store_text_el);

                // TEXT
                const stock_despatch_text = stock_information_el.getAttribute(deliveryElementSelectors.stock_despatch_text);
                const data_feed_text = stock_information_el.getAttribute(deliveryElementSelectors.data_feed_text);
                const in_store_text = stock_available_el.getAttribute(deliveryElementSelectors.in_store_online_text);
                const online_only_text = stock_available_el.getAttribute(deliveryElementSelectors.in_online_only_text);

                const stock_locations_obj = JSON.parse(stock_locations_el.getAttribute(deliveryElementSelectors.stock_locations));
                const variant_stock_locations = stock_locations_obj[variant.id];
                const feed_stock = variant_stock_locations["feed_stock"];
                const shop_location_stock = variant_stock_locations["shop_location"];
                const warehouse_stock = variant_stock_locations["warehouse_stock_record"];

                // IF ONLY FEED STOCK AVAILABLE
                if (shop_location_stock > 0 || warehouse_stock > 0) {
                    feed_text_el.innerHTML = stock_despatch_text;
                    stock_available_text_el.innerHTML = in_store_text;
                    stock_available_el.classList.remove('hide');
                    stock_information_el.classList.remove('hide');
                    countdown_el.classList.remove('hide');
                } else if (shop_location_stock < 1 && warehouse_stock < 1 && feed_stock > 0) {
                    feed_text_el.innerHTML = data_feed_text;
                    stock_available_text_el.innerHTML = online_only_text;
                    countdown_el.classList.add('hide');
                    stock_available_el.classList.remove('hide');
                    stock_information_el.classList.remove('hide');
                    if (data_feed_text == "") {
                        stock_information_el.classList.add('hide');
                    }
                } else if (shop_location_stock < 1 && warehouse_stock < 1 && feed_stock < 1) {
                    countdown_el.classList.add('hide');
                    stock_available_el.classList.add('hide');
                    stock_information_el.classList.add('hide');
                }
            }

        }
    }


}


// Product Card Events
document.body.addEventListener('click', (e) => {
    const target = e.target;
    const productCard = target.closest( '.product-card' );
    if ( productCard ) {

        // Handle Quick Add Click
        if ( target.getAttribute('data-quick-add') != null ) {
            const productCardForm = productCard.querySelector('form.product-form.product-card-form');

            if ( productCardForm ) {

                productCardForm.classList.add('modal-open');

                if ( productCardForm && productCard.getAttribute('quick-add-initialised') == null ) {
                    new window.ProductForm( productCardForm );

                    // Add attribute to ensure intialisation once
                    productCard.setAttribute('quick-add-initialised', '');
                } else {
                }

            }

        } else if ( target.getAttribute('data-close-quick-add') !== null ) {
            e.preventDefault();
            const productCardForm = productCard.querySelector('form.product-form.product-card-form');

            if ( productCardForm ) productCardForm.classList.remove('modal-open');

        }

    }

    // Custom Select Active classes
    if ( target.classList.contains('select-output') && !target.closest(`.custom-select-wrapper`).classList.contains('active') ) {
        const customSelects = document.querySelectorAll(`.custom-select-wrapper`);

        if ( customSelects && customSelects.length > 0 ) {

            customSelects.forEach( customSelect => {
                customSelect.classList.remove('active');
            });

            if ( target.classList.contains('select-output') && !target.closest(`.custom-select-wrapper`).classList.contains('active') ) {
                target.closest(`.custom-select-wrapper`).classList.add('active');
            }

        }
    } else {
        const activeCustomSelects = document.querySelectorAll(`.custom-select-wrapper.active`);
        if ( activeCustomSelects && activeCustomSelects.length > 0 ) {
            activeCustomSelects.forEach( activeSelect => {
                activeSelect.classList.remove('active');
            });
        }

    }

})